import { Link } from "react-router-dom";
import { useSite } from "@/lib/site";

const DEFAULT_DESC = "Ecosistema Digitale per l'Innovazione: accompagniamo le imprese del terziario nella trasformazione digitale attraverso la rete degli sportelli SPIN.";

export const Footer = () => {
    const s = useSite();
    const tel = (s.footer_telefono || "").replace(/[^+0-9]/g, "");
    return (
        <footer className="bg-edi-surface border-t border-edi-border mt-16" data-testid="site-footer">
            <div className="mx-auto max-w-6xl px-4 sm:px-6 py-10 grid gap-6 md:grid-cols-[2fr_1fr]">
                <div>
                    <p className="font-heading text-lg font-bold">EDI Confcommercio</p>
                    <p className="mt-2 text-sm max-w-xl" data-testid="footer-description">{s.footer_descrizione || DEFAULT_DESC}</p>
                    <ul className="mt-3 space-y-1 text-sm" aria-label="Contatti">
                        {s.footer_indirizzo && <li data-testid="footer-address">{s.footer_indirizzo}</li>}
                        {s.footer_telefono && <li>Tel. <a href={`tel:${tel}`} className="underline" data-testid="footer-phone">{s.footer_telefono}</a></li>}
                        {s.footer_email && <li>Email: <a href={`mailto:${s.footer_email}`} className="underline" data-testid="footer-email">{s.footer_email}</a></li>}
                        {s.footer_pec && <li>PEC: <a href={`mailto:${s.footer_pec}`} className="underline" data-testid="footer-pec">{s.footer_pec}</a></li>}
                        {s.footer_sito && <li>Sito: <a href={s.footer_sito} target="_blank" rel="noopener noreferrer" className="underline" data-testid="footer-site">{s.footer_sito.replace(/^https:\/\//, "")}<span className="sr-only"> (si apre in una nuova scheda)</span></a></li>}
                    </ul>
                </div>
                <nav aria-label="Link del piè di pagina">
                    <ul className="space-y-2 text-sm">
                        <li>{s.privacy_policy_url
                            ? <a href={s.privacy_policy_url} target="_blank" rel="noopener noreferrer" className="text-edi-text underline" data-testid="footer-privacy-link">Informativa privacy<span className="sr-only"> (si apre in una nuova scheda)</span></a>
                            : <Link to="/informativa-privacy" className="text-edi-text underline" data-testid="footer-privacy-link">Informativa privacy</Link>}</li>
                        <li><Link to="/accessibilita" className="text-edi-text underline" data-testid="footer-accessibility-link">Dichiarazione di accessibilità</Link></li>
                    </ul>
                </nav>
            </div>
            <div className="border-t border-edi-border">
                <p className="mx-auto max-w-6xl px-4 sm:px-6 py-4 text-sm">© {new Date().getFullYear()} EDI Confcommercio — Tutti i diritti riservati</p>
            </div>
        </footer>
    );
};
